<template>
  <div>
    <!-- breadcrumb area start -->
    <div class="breadcrumb-area">
      <div class="row">
        <div class="col-md-12">
          <ol class="breadcrumb font-class">
            <li><a href="/#/home" v-on:click="sendMsg"><span class="fa fa-home"></span></a></li>
            <li><a href="/#/center" v-on:click="sendMsg">核心业务</a></li>
            <li class="active">高层结构振动监测</li>
          </ol>
        </div>
      </div>
    </div>
    <!-- breadcrumb area end -->

    <!-- contact information start -->
    <div class="contant-information pt-20">
      <div class="row">
        <div class="center_column col-xs-12 col-sm-12">
          <div class="rte">
            <h1 style="text-align:center;font-size: 20px">高层结构振动监测</h1>
            <hr>
            <p class="titleP">高层结构振动监测的意义</p>
            <p>随着结构高度的不断增加，高层建筑呈现出质量轻、柔度大以及自振频率低、阻尼比低等特点。高层建筑较低的自振频率与台风脉动风荷载的主要频率段比较接近，在台风作用下的可能产生较大的风致响应。因此，监测超高层建筑的动力响应，研究超高层建筑的动力特性很有必要。</p>
            <p class="titleP">高层结构振动监测所用到的设备</p>
            <p>传感器：BY-S07、941B
              传感器特点：传感器使用了无源伺服反馈技术，输出模拟电压信号，宽频带、高分辨率、大动态范围、抗冲击性能好，可直接与数据采集仪配接。传感器可在恶劣环境下工作，-40℃~+85℃。耐潮耐湿，BY-S07防护等级为IP67。
              采集设备：D1000型数据采集仪、D3000型数据采集仪
              D1000型数据采集仪每通道内置独立的24bitADC，保证每通道最高以128kHz的采样率同步采样，内置程控放大和滤波器，可完成信号的高速采集。采集仪可多台级联，可支持8台采集仪128个采集通道同步采样。D1000型采集仪支持电压/IEPE信号输入；采集软件可对数据进行时域分析、频谱分析、传递函数分析、冲击系数、模态分析得到峰峰值、有效值、自振频率、阻尼、振型等。 D1000型数据采集仪连接方式为电脑、网线、采集仪，适用于检测。
              D3000型动态数据采集仪采用独立24bitADC并行同步采集，动态范围可达120db以上，设备可级联扩展至128通道，采用直流适配器15V供电，也支持外接直流电池（蓄电池）供电，有外部供电时时使用外部供电，并给内置电池供电，无外部供电时，自动切换至内置电池供电，内置TF储存卡，在自然灾害来临（断电/断网），仪器仍正常工作，数据储存至TF卡中，保证数据采集的连续性。采集仪开放底层协议，可使用C语言、Python语言等进行对接，还可对接用户的监测平台。因此，D3000型动态数据采集仪适用于长期健康监测。数据的输出格式可为txt、Excel等，可以对接国内外知名分析软件。
            </p>
            <p class="titleP">高层结构振动监测流程图</p>
            <div style="width:80%;margin: 0 auto 50px">
              <img src="../../../assets/center/high-rise/f1.png" alt="" style="width:100%;height:auto;">
            </div>
            <p class="titleP">高层结构振动监测案例</p>
            <p>某高层建筑振动监测现场照片</p>
            <div style="width:80%;margin: 0 auto 50px">
              <img src="../../../assets/center/high-rise/c1.png" alt="" style="width:100%;height:auto;">
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- contact information end -->
  </div>
</template>

<script>
import {getContactDetail} from '../../../utils/api'

export default {
  name: 'contact',
  data () {
    return {
      contactData: {},
      formLeft: {
        input1: '',
        input2: '',
        input3: ''
      }
    }
  },
  mounted () {
    this.getContactDetail()
  },
  methods: {
    render (String) {
      let temp = ''
      for (let item of String.split('\n')) {
        temp += item + '<br>'
      }
      return temp
    },
    async getContactDetail () {
      let contactData01 = await getContactDetail()
      if (localStorage.getItem('Language') === 'zh') {
        this.contactData = {
          address: this.render(contactData01.address_zh),
          email: contactData01.email,
          phone: contactData01.phone,
          work_time: this.render(contactData01.work_time_zh)
        }
      } else {
        this.contactData = {
          address: this.render(contactData01.address_en),
          email: contactData01.email,
          phone: contactData01.phone,
          work_time: this.render(contactData01.work_time_en)
        }
      }
      // console.log(this.contactData)
    },
    sendMsg () {
      this.$emit('headCurrent', 0)
      window.sessionStorage.setItem('currentFirstIndex', 0)
    }
  }
}
</script>

<!-- 面包屑导航样式 -->
<style scoped>
  .breadcrumb>li+li:before {
    padding: 0 5px;
    color: #000;
    content: ">";
    font-weight: lighter;
  }

  .breadcrumb>li span{
    font-size: 16px;
  }
</style>

<!-- 内容样式 -->
<style scoped>
  .center_column{
    min-height: 400px;
  }

  .center_column p{
    font-size: 14px;
    line-height: 22px;
    margin: 0 0 9px;
    padding: 0;
    border: 0;
    vertical-align: baseline;
    color: #000;
    position: relative;
    font-family: 宋体;
  }

  .titleP{
    padding-left: 10px!important;
    font-size: 16px;
    font-weight: bold;
    margin: 10px 0 10px!important;
    text-indent: 0!important;
  }

  .titleP:before{
    position: absolute;
    left: -5px;
    top: 0;
    content: "\2726";
    font-size: 14px;
  }

  .rte {
    background: transparent none repeat scroll 0 0;
    text-indent: 26px;
  }

  .rte img{
    width: 100%;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: 700;
    color: #000;
  }
</style>



// WEBPACK FOOTER //
// src/components/center/high-rise/high-rise.vue